import { createAction } from '@reduxjs/toolkit';
import { ZoomState } from 'features/content-zoom/types';

export const signalingLockedContentZoomUpdated = createAction<ZoomState>(
  'signaling/lockedContentZoomUpdated'
);
